module.exports = __webpack_public_path__ + "img/codeImg.df927825.png";